import { Switch } from 'uikit/Switch'

export const SwitchForm = ({ field, form, label, ...props }) => {
  const handleChange = (e) => form.setFieldValue(field.name, e.checked)

  return <Switch onCheckedChange={handleChange} checked={field.value} label={label} {...props} />
}
